import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../modules/infra/i18n';
import Icon, { GLYPHS } from '../../../common/icon';
import AddBarberPrefix from '../../../common/RoleAwareLink';

const EcommerceNavigation = ({ openedIsOn, onMenuItemClick, title, toggleDropdown }) => {
  const dropdownClass = classNames('c-header-primary__dropdown js-toggle', {
    'is-active': openedIsOn,
  });

  const dropdownListClass = classNames('c-header-primary-menu', {
    'is-active': openedIsOn,
  });

  return (
    <div className="c-header-primary__item u-position-relative">
      <button type="button" className={dropdownClass} onClick={toggleDropdown}>
        <div className="c-heading c-heading--light u-mr-- u-visible-inline-block-for-medium-and-up">
          {title === 'Ecommerce' ? t('products:navigation.ecommerce.title') : title}
        </div>
        <Icon glyph={GLYPHS.arrowCircle} size="medium" className="c-dropdown-icon" />
      </button>
      <div className={dropdownListClass}>
        <ul className="c-separator-list">
          <li className="c-separator-list__item c-separator-list__item--header">
            <AddBarberPrefix
              to="/products/shopify"
              onlyActiveOnIndex
              className="c-header-primary-menu__link"
              onClick={() => onMenuItemClick('Shopify')}
              activeClassName="c-header-primary-menu__link is-active"
            >
              {t('products:navigation.ecommerce.shopify')}
            </AddBarberPrefix>
          </li>
        </ul>
      </div>
    </div>
  );
};

EcommerceNavigation.propTypes = {
  openedIsOn: PropTypes.bool.isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
};

export default EcommerceNavigation;
